import React, { useState } from "react";
import {
  AppBar,
  Backdrop,
  Box,
  Dialog,
  Fab,
  IconButton,
  InputAdornment,
  Slide,
  TextField,
  Toolbar,
  Typography,
  debounce,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useQuery } from "react-query";
import { Add, Close, Search } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";

import { LoadingBox } from "../../../../../components/utils";

import AmountsTable from "./components/AmountsTable";
import { AmountsDialog } from "./components/AmountsDialog";

import { getAmounts, getAmount } from "../../../../services/pwsApi";

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "primary",
    backgroundColor: "rgba(0, 0, 0, 0.25) !important",
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(10),
    right: theme.spacing(2),
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Amounts() {
  const classes = useStyles();
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);

  const companyCode = searchParams.get("company_code");
  const amountId = searchParams.get("amount_id");

  const tablePageIndex = Number(searchParams.get("page") ?? 1);
  const tablePageSize = Number(searchParams.get("page_size") ?? 50);

  const amountsQuery = useQuery(
    ["amounts", companyCode, tablePageIndex, tablePageSize, searchQuery],
    () =>
      getAmounts(
        companyCode.slice(0, 3),
        companyCode.slice(3, 7),
        searchQuery,
        {
          page: tablePageIndex,
          perPage: tablePageSize,
        },
      ),
    {
      enabled: !!companyCode,
    },
  );

  const amountQuery = useQuery(
    ["amount", amountId],
    () => getAmount(companyCode.slice(0, 3), companyCode.slice(3, 7), amountId),
    {
      enabled: !!amountId,
      onSuccess: () => setDialogOpen(true),
    },
  );

  let amount = amountQuery.data?.data?.data;
  amount = amount
    ? {
        amountId: null,
        hasConfigContabil: amount?.hasConfigContabil ?? 2,
        // cbo: singleFunction.RJ_CODCBO,
      }
    : null;

  const handleCloseDialog = () => {
    searchParams.delete("screen");
    setSearchParams(searchParams);
  };

  const handleCloseAmountsDialog = () => {
    searchParams.delete("amount_id");
    setSearchParams(searchParams);
    setDialogOpen(false);
  };

  const handleCreateAmount = () => {
    setDialogOpen(true);
  };

  const searchDelayed = debounce(query => {
    setSearchQuery(query);
  }, 1000);

  const amounts = amountsQuery?.data?.data?.data ?? [];
  const rows = amountsQuery?.data?.data?.meta?.total ?? 0;

  return (
    <Dialog
      fullScreen
      open
      onClose={handleCloseDialog}
      TransitionComponent={Transition}
    >
      {dialogOpen && (
        <AmountsDialog onClose={handleCloseAmountsDialog} data={amount} />
      )}

      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleCloseDialog}
            aria-label="close"
          >
            <Close />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Verbas
          </Typography>
        </Toolbar>
      </AppBar>

      <Backdrop className={classes.backdrop} open={amounts.isLoading || false}>
        <LoadingBox />
      </Backdrop>

      <Box sx={{ height: "calc(100% - 64px)", padding: "15px" }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
          <TextField
            style={{ width: "400px" }}
            label="Pesquisar"
            variant="outlined"
            fullWidth
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            onChange={event => {
              searchDelayed(event.target.value);
            }}
          />
        </Box>

        <AmountsTable data={amounts} rows={rows} />
      </Box>

      {/* <Fab
        color="primary"
        aria-label="add"
        className={classes.fab}
        onClick={handleCreateAmount}
      >
        <Add />
      </Fab> */}
    </Dialog>
  );
}
